import React from 'react';
import { useStyles } from '@webapps/styles';
import { CheckCircleOutline, CheckRounded, ReplayRounded, ShareOutlined } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { useCalendar } from '../Stores/CalendarProvider';


export default function ActivityInSchedule({ configurationStatus, periods, periodSummary, handleOpenDeletePeriodModal }) {
  const { classes, global, css, cx } = useStyles(styles);


  const configuratedHours = configurationStatus?.reduce((acc, curr) => acc + curr.configuratedHours, 0);

  const formationDays = periods.filter(period => period.type === "FORMATION").reduce((acc, curr) => acc + curr.days, 0);
  const formationHours = periods.filter(period => period.type === "FORMATION").reduce((acc, curr) => acc + curr.hours, 0);

  const formationDaysSummary = periodSummary?.summary?.FORMATION;

  console.log("periodSummary", periodSummary);



  return (
    <div className={classes.container}>
      <div className={global.title}>Activités</div>
      <div className={classes.content}>
        <div className={classes.row}>
          <div className={classes.rowItem}>
            <div className={cx(classes.rowItemIconContainer, css({
              backgroundColor: "#0060f9",
            }))}>
              <CheckRounded className={classes.rowItemIcon} />
            </div>
            <div className={classes.rowItemTitle}>En formation</div>
          </div>
          <div className={classes.rowItem}>{formationDaysSummary?.days}j - {formationDaysSummary?.hours}h</div>
        </div>
        <div className={classes.row}>
          <div className={classes.rowItem}>
            <div className={cx(classes.rowItemIconContainer, css({
              backgroundColor: "#dbfad8",
              border: "1px dashed #008000",
            }))}>
              <CheckRounded className={cx(classes.rowItemIcon, css({
                fill: "#008000",
              }))} />
            </div>
            <div className={classes.rowItemTitle}>Emploi du temps configuré</div>
          </div>
          <div className={classes.rowItem}>{configurationStatus?.length}j - {configuratedHours}h</div>
        </div>
      </div>
      <Button className={classes.resetButton} onClick={handleOpenDeletePeriodModal}>
        <ReplayRounded className={classes.resetButtonIcon} />
        <div className={classes.resetButtonText}>Réinitialiser l'emploi du temps</div>
      </Button>
    </div>
  );
}

const styles = ({ spacing }) => ({
  container: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    justifyContent: "flex-start",
    paddingBottom: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "20px",
    position: "relative",
    gap: "16px",
    overflow: "visible",
  },
  content: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    justifyContent: "flex-start",
    position: "relative",
    width: "100%",
    gap: "4px",
    overflow: "hidden",
  },
  row: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  rowItem: {
    display: "flex",
    alignContent: "center",
    flexDirection: "row",

    gap: "10px",
    overflow: "hidden",
    placeItems: "center",
  },
  rowItemIconContainer: {
    backgroundColor: "#0060f9",
    borderRadius: "400px",
    padding: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  rowItemIcon: {
    height: "17px",
    width: "17px",
    position: "relative",
    fill: "#ffffff",
    // backgroundColor: "#0060f9",
    // borderRadius: "400px",
    // padding: "3px",
    // width: "17px",
    // height: "17px",
  },
  rowItemTitle: {
    fontFamily: "\"Montserrat\", sans-serif",
    fontSize: "14px",
    fontWeight: "500",
    color: "#152652",
  },
  rowItemSeparator: {
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    border: "1px dashed #008000",
    backgroundColor: "#dbfad8",
    borderRadius: "12px",
    padding: "3px",
  },
  rowItemSeparatorIcon: {
    height: "17px",
    position: "relative",
    width: "17px",
    fill: "#008000",
  },
  resetButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f50057",
    height: "40px",
    width: "100%",
    borderRadius: "40px",
    padding: "5px 15px",
    position: "relative",
    gap: "8px",
    overflow: "visible",
    "&:hover": {
      backgroundColor: "#f50057",
    },
  },
  resetButtonText: {
    fontFamily: "\"Montserrat\", sans-serif",
    fontSize: "13.5px",
    fontWeight: "500",
    lineHeight: "23.625px",
    textAlignment: "center",
    color: "#ffffff",
  },
  resetButtonIcon: {
    height: "24px",
    position: "relative",
    width: "24px",
    fill: "#ffffff",
  },
});